import { store } from "../Store";
import { fetchNotifications } from "./fetchNotifications";

export async function fetchNextNotifications() {
  return fetchNotifications((await store).me!.notifications.map((v) => v.timestamp).reduce((a, b) => (a < b ? a : b)));
}
